import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-column">
          <h3 className="footer-title">Quick Links</h3>
          <ul className="footer-links">
            <li><Link to="/" className="footer-link">Home</Link></li>
            <li><Link to="/movies" className="footer-link">Movies</Link></li>
            <li><Link to="/tv-shows" className="footer-link">TV Shows</Link></li>
            <li><Link to="/my-list" className="footer-link">My List</Link></li>
            <li><Link to="/movie-list" className="footer-link">Movie List</Link></li>
          </ul>
        </div>
        <div className="footer-column">
          <h3 className="footer-title">Resources</h3>
          <ul className="footer-links">
            <li><a href="#" className="footer-link">Support</a></li>
            <li><a href="#" className="footer-link">Privacy Policy</a></li>
            <li><a href="#" className="footer-link">Terms of Service</a></li>
          </ul>
        </div>
        <div className="footer-column">
          <h3 className="footer-title">Contact Us</h3>
          <ul className="footer-links">
            <li>Email: kennethmburu21@gmail.com</li>
            <li>Phone: +254 742-164-615</li>
          </ul>
          <div className="social-icons">
            <a href="#" className="social-icon"><i className="fab fa-facebook-f"></i></a>
            <a href="#" className="social-icon"><i className="fab fa-twitter"></i></a>
            <a href="#" className="social-icon"><i className="fab fa-instagram"></i></a>
            <a href="#" className="social-icon"><i className="fab fa-linkedin"></i></a>
          </div>
        </div>
      </div>
      <div className="footer-bottom">
        <p>&copy; {new Date().getFullYear()} CineFlicks. All Rights Reserved.</p>
      </div>
    </footer>
  );
}

export default Footer;
